import { sessionToken, sessionUserId } from 'utils/session';

export const ALPHA_POPUP_SESSION = 'mspp.alpha.popupSession';

export interface IAlphaPopupSession {
  accessToken: string;
  userId: string;
}

let held: IAlphaPopupSession | null = null;
let popupContext = false;
const expiryListeners = new Set<() => void>();

const parse = (raw: string | null): IAlphaPopupSession | null => {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<IAlphaPopupSession> | null;
    return typeof value?.accessToken === 'string' &&
      value.accessToken !== '' &&
      typeof value.userId === 'string' &&
      value.userId !== ''
      ? { accessToken: value.accessToken, userId: value.userId }
      : null;
  } catch {
    return null;
  }
};

const stored = (): IAlphaPopupSession | null => {
  try {
    return parse(window.sessionStorage.getItem(ALPHA_POPUP_SESSION));
  } catch {
    return null;
  }
};

export const heldAlphaPopupSession = (): IAlphaPopupSession | null => {
  held ??= stored();
  if (held) popupContext = true;
  return held;
};

export const inAlphaPopup = (): boolean => heldAlphaPopupSession() !== null || popupContext;

export const holdAlphaPopupSession = ({ accessToken, userId }: IAlphaPopupSession): void => {
  held = { accessToken, userId };
  popupContext = true;
  try {
    window.sessionStorage.setItem(ALPHA_POPUP_SESSION, JSON.stringify(held));
  } catch {
    return undefined;
  }
};

export const dropAlphaPopupSession = (): void => {
  held = null;
  try {
    window.sessionStorage.removeItem(ALPHA_POPUP_SESSION);
  } catch {
    return undefined;
  }
};

export const expireAlphaPopupSession = (): void => {
  dropAlphaPopupSession();
  expiryListeners.forEach(listener => {
    listener();
  });
};

export const onAlphaPopupSessionExpired = (listener: () => void): (() => void) => {
  expiryListeners.add(listener);
  return () => {
    expiryListeners.delete(listener);
  };
};

export const alphaSessionToken = (): string | null =>
  heldAlphaPopupSession()?.accessToken ?? (popupContext ? null : sessionToken());

export const alphaSessionUserId = (): string | null =>
  heldAlphaPopupSession()?.userId ?? (popupContext ? null : sessionUserId());
